import { useLoginUser } from "./useAuth";

export const useIsHeadNurse = () => {
  const loginUser = useLoginUser();
  return loginUser?.is_head_nurse;
};
